// extracted by mini-css-extract-plugin
export default {"icons":"DetailCards_icons__y1CzJ","greyText":"DetailCards_greyText__9ULwv"};